export const CREATE_ADS_CAMPAIGN = "CREATE_ADS_CAMPAIGN";
export const GET_CAMPAIGN_LIST = "GET_CAMPAIGN_LIST";
export const UPDATE_CAMPAIGN = "UPDATE_CAMPAIGN";
export const INVOICE_CREATION = "INVOICE_CREATION";